export default [
  'Length',
  'EllipticalROI',
  'Bidirectional',
  'ArrowAnnotate',
  'Angle',
  'CobbAngle',
  'Probe',
  'RectangleROI',
  'PlanarFreehandROI',
];
